import {useContext} from 'react';
import block from 'bem-cn-lite';
import {Text, Icon} from '@gravity-ui/uikit';
import {Clock, MapPin} from '@gravity-ui/icons';
import {AppContext} from '@app/context';

import './StoreAddress.scss';

const b = block('store-address');

const parseWorkingHours = (item: string) => {
    const match = item.match(/^(.+?)\s*:\s*(\d{1,2}:\d{2})(?:\s*-{1,2}\s*(\d{1,2}:\d{2}))?\s*$/);

    if (!match) {
        return {day: item.trim(), timeFrom: '', timeTo: ''};
    }

    return {
        day: match[1].trim(),
        timeFrom: match[2],
        timeTo: match[3] ?? ''
    };
};

export const StoreAddress: React.FC = () => {
    const {
        state: {clientDetails}
    } = useContext(AppContext);

    const {address = '', mapImageUrl, mapUrl, workingHours = []} = clientDetails?.warehouse ?? {};

    return (
        <>
            <div className={b()}>
                <Text variant="header-1">Склад</Text>

                {mapImageUrl && (
                    <a
                        className={b('store-map-link')}
                        href={mapUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={mapImageUrl} className={b('store-map')} alt="Карта склада" />
                    </a>
                )}

                <Text className={b('address')} variant="body-2">
                    <Icon className={b('icon')} data={MapPin} />
                    {address}
                </Text>

                <div className={b('worktime-container')}>
                    <Icon className={b('icon')} data={Clock} />
                    <table className={b('worktime-content')}>
                        <tbody>
                            {workingHours.map((item, index) => {
                                const {day, timeFrom, timeTo} = parseWorkingHours(item);

                                return (
                                    <tr className={b('content')} key={index}>
                                        <td className={b('content-day')}>
                                            <Text variant="body-2">{day ? `${day}:` : ''}</Text>
                                        </td>
                                        <td className={b('content-time')}>
                                            <Text variant="body-2">{timeFrom}</Text>
                                        </td>
                                        <td className={b('content-separator')}>
                                            <Text variant="body-2">{timeTo ? '-' : ''}</Text>
                                        </td>
                                        <td className={b('content-time')}>
                                            <Text variant="body-2">{timeTo}</Text>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};
